module.exports = __webpack_public_path__ + "static/media/symptoms-image-1@2x.ce619a29.png";